import { createWebHashHistory, createRouter } from 'vue-router'
// import App from '../App.vue'
import Sales from '@/pages/SalesData.vue'
import Import from '@/pages/ImportData.vue'
import Keikaku from '@/pages/KeikakumeisaiData.vue'
import AnalyzeData from '@/pages/AnalyzeData.vue'
import UserLogin from '@/pages/UserLogin.vue'
import UserRegister from '@/pages/UserRegister.vue'
import ForgotPassword from '@/pages/UserForgotPassword.vue'
import AIAnalytics from '@/pages/AIAnalytics.vue'
import Verification from '@/pages/VerificationPage.vue'
import ReturnedItems from '@/pages/ReturnedItems.vue'
import MagentoTest from '@/pages/MagentoTest.vue'
import SamplesRequest from '@/pages/ProductSampleRequest.vue'
import Estimations from '@/pages/EstimationsPage.vue'
import SharePoint_EstimationPage from '@/pages/SharePoint_EstimationPage.vue'
import MoldData from '@/pages/MoldData.vue'
import ResultDetails from '@/pages/ResultDetails.vue'
import SharePoint_ResultDetails from '@/pages/SharePoint_ResultDetails.vue'

const routes = [
    {path: '/', component: UserLogin,},
    {path: '/register', component: UserRegister},
    {path: '/forgotpassword', component: ForgotPassword},
    {path: '/sales', component: Sales},
    {path: '/import', component: Import},
    {path: '/keikakumeisai', component: Keikaku},
    {path: '/analytics', component: AnalyzeData},
    {path: '/ai', component: AIAnalytics},
    {path: '/verification', component: Verification},
    {path: '/verification#', component: Verification},
    {path: '/returneditems', component: ReturnedItems},
    {path: '/magento', component: MagentoTest},
    {path: '/samples', component: SamplesRequest},
    {path: '/molds', component: MoldData },
    {path: '/estimations', component: Estimations},
    {path: '/estimations/details', component: ResultDetails},
    {   
        path: '/sp_estimations',
        component: SharePoint_EstimationPage,
        beforeEnter: (to, from, next) => {
            const apiKey = to.query.apiKey;

            if (!apiKey || apiKey === '')
            {
                console.log('Return to login', apiKey);
                return next({ path: '/' });
            }

            return next();
        }
    },
    {
        path: '/sp_estimations/details',
        component: SharePoint_ResultDetails,
        beforeEnter: (to, from, next) => {
            const apiKey = to.query.apiKey;

            if (!apiKey || apiKey === '')
            {
                console.log('Return to login', apiKey);
                return next({ path: '/' });
            }

            return next();
        }
    }
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

export default router;